export const MANAGE_CONNECTIONS = {
    APPROVE_REQUEST: "approve-request-btn",
    DENY_REQUEST: "deny-request-btn",
    ARCHIVE_BTN: "archive-btn",
    MENU_ITEMS: {
        POPUP: "actions-menu-popup",
        ACTION_ITEMS: {
            ADD_BUYER_BTN: "add-buyer-btn",
            IN_REVIEW_BTN: "in-review-btn",
        },
        WRAPPER: "wrapper",
    },
    IN_REVIEW_BTN: "in-review-btn",
    COUNTER: "request-counter",
    COLUMNS_BTN: "columns-btn",
    COLUMNS_LIST: "columns-list",
    SEARCH: "search",
    SORT: "sort",
    DAYS_PENDING: "days-pending",
    REQUEST_DATE: "request-date",
    REQUEST_STATUS: "request-status",
    RETAILER_NAME: "retailer-name",
    RETAILER_WEBSITE: "retailer-website",
    BUYER_NAME: "buyer-name",
    AVATAR: "avatar",
    CLOSE_RETAILER_POPUP: "close-retailer-popup",
    BUYER: {
        OPEN_NOTES: "open-notes-btn",
        NOTES: "notes-text",
        CLOSE_NOTES: "close-notes",
        EMAIL: "retailer-email",
    },
    ACCOUNT_FORM: {
        NAME: "company-name",
        CREATE_BTN: "create-btn",
        CONTINUE: "continue-editing",
        NO_SAVE: "close-no-save",
        CLASSIFICATIONS: "classifications",
        CATEGORIES: "categories",
        BUYERS: "buyers",
        BRANDS_STOCKED: "brands-stocked",
        CONTACT_INFO: "contact-info",
        ADD_ADDRESS: "add-address",
        REMOVE_ADDRESS: "remove-address",
        CONTACT_INFO_DETAILS: {
            EMAIL: "retailer-email",
            WEBSITE: "retailer-website",
        },
    },
    DENY: {
        POPUP_DISMISS: "popup-dismiss-btn",
        POPUP_CONFIRM: "popup-confirm-btn",
        REASONS: "reasons-to-deny",
        COMMENTS: "comments-input",
        SUBMIT: "deny-submit-btn",
        DISMISS: "deny-dismiss-btn",
    },
    ARCHIVE: {
        POPUP_CANCEL: "archive-popup-cancel-btn",
        POPUP_CONFIRM: "archive-popup-confirm-btn",
    },
    ARCHIVED_FILTER: {
        FILTER_ARCHIVED: "filter-archived",
        RADIO_ARCHIVED: "radio-archived",
        RADIO_NOT_ARCHIVED: "radio-not-archived",
    },
    ADD_BUYER_FORM: {
        SAVE_BTN: "save-btn",
        CANCEL_BTN: "cancel-btn",
        SELECT_COMPANY: "select-company-dropdown",
        EMAIL_INPUT: "email-input",
    },
    MOBILE_MORE_ACTIONS: "more-actions-btn",
    SEND_LINESHEET: "send-linesheet",
    SNACK_BAR_MESSAGE: "snackbar-message",
    LIGHTSPEED_MERCHANT_ICON: {
        ACTIVE_MERCHANT_INDICATOR: "active-merchant-indicator-",
        ACTIVE_ICON: "active-lightspeed-merchant-account-icon",
        NO_ICON: "lightspeed-merchant-no-icon",
    },
};
